export const SCOUT_MISSIONS = [
  {
    key: "leftist-political-figures",
    label: "Leftist political figures",
    pillar: "Politics",
    brief:
      "Nationally: leftist and progressive political figures in the mold of Jamaal Bowman — former or current members of Congress, state legislators, DSA-aligned or movement-left electeds, labor organizers, civil-rights and housing-justice leaders, and insurgent primary challengers who speak bluntly about party gatekeeping, money in politics, and institutional failure. Prefer public press/booking emails, active X or Bluesky, and prior podcast appearances.",
  },
  {
    key: "breakthrough-scientists",
    label: "Breakthrough scientists",
    pillar: "Science",
    brief:
      "Nationally: working scientists and science communicators advancing revolutionary breakthroughs — in the mold of Dr Ben Miles (YouTube physicist) — on fusion, quantum computing, space, longevity, neuroscience, AI-for-science, materials, and frontier physics, who run active YouTube/Substack/podcast channels and challenge orthodoxy with evidence. Prefer channel business emails, lab pages, and prior podcast guest spots.",
  },
  {
    key: "conservative-theologians",
    label: "Conservative theologians",
    pillar: "Religion",
    brief:
      "Nationally: theologians, seminary professors, pastors, priests, rabbis, and imams with conservative or traditionalist convictions who debate secularism, morality without religion, and faith in public life — and who welcome adversarial questions from a progressive, secular host. Prefer public institutional emails and prior small-podcast appearances.",
  },
  {
    key: "religious-liberty",
    label: "Religious-liberty advocates",
    pillar: "Politics",
    brief:
      "Nationally: religious-liberty litigators, law professors, and advocacy leaders (e.g. at faith-based legal groups or law-school religion clinics) who argue church-and-state and conscience-exemption cases in public and can defend them against civil-rights pushback. Prefer bios with a public email or press contact and prior podcast interviews.",
  },
  {
    key: "traditionalist-philosophers",
    label: "Traditionalist philosophers",
    pillar: "Philosophy",
    brief:
      "Nationally: philosophers, ethicists, and public intellectuals defending traditional societal norms — natural-law theory, virtue ethics, family structure, limits on individual autonomy, skepticism of progressive social change — who publish for general audiences and engage critics. Prefer faculty pages with emails, Substack authors, and prior small-show guests.",
  },
  {
    key: "conservative-economists",
    label: "Conservative economists",
    pillar: "Politics",
    brief:
      "Nationally: free-market and fiscally conservative economists and policy scholars (universities, state think tanks) who will challenge progressive positions on housing, taxation, data-center incentives, and public spending with data. Prefer public emails, recent op-eds, and small-podcast history.",
  },
  {
    key: "heterodox-scientists",
    label: "Heterodox scientists",
    pillar: "Science",
    brief:
      "Nationally: working scientists, physicians, and public-health researchers who have publicly challenged consensus framing in their own field — on climate policy, vaccines, gender medicine, or AI risk — from evidence, and who can withstand rigorous follow-up. Prefer faculty emails, active X/Substack, and prior podcast interviews.",
  },
  {
    key: "faith-and-society",
    label: "Faith & societal norms",
    pillar: "Religion",
    brief:
      "Nationally: religious leaders, scholars, and writers who argue that faith should shape public norms on marriage, family, education, and law — and who will defend that against a secular progressive host. Prefer people with a public congregational or institutional contact and a record of debating on small independent shows.",
  },
  {
    key: "ballot",
    label: "Ballot-access scholars",
    pillar: "Politics",
    brief:
      "Nationally: political scientists and election-law professors who have published or spoken publicly about ballot-access rules, signature thresholds, and barriers to independent or third-party candidates. Prefer public faculty emails and a history of small-podcast or local-media appearances.",
  },
  {
    key: "candid-officials",
    label: "Candid officials",
    pillar: "Politics",
    brief:
      "Nationally (Georgia a mild bonus): current or former county commissioners, mayors, state legislators, and school-board members — especially conservatives — known for blunt, on-the-record candor and willingness to be challenged. Prefer public office emails and recent local-media interviews.",
  },
  {
    key: "indie-journalists",
    label: "Independent journalists",
    pillar: "Politics",
    brief:
      "Nationally: independent and local journalists, Substack writers, and small-outlet reporters — across the spectrum, including right-leaning — covering politics, media gatekeeping, or party primaries outside legacy cable news. Prefer public contact pages and a track record of guesting on independent podcasts.",
  },
];
